import {
  FETCH_NOTIFY,
  FETCH_NOTIFY_FAILED,
  FETCH_NOTIFY_SUCCEED,
} from './action_types';

export default {
  fetchNotifyAction: (params, callback) => ({
    type: FETCH_NOTIFY,
    params,
    callback,
  }),
  fetchNotifyActionSucceed: (data) => ({
    type: FETCH_NOTIFY_SUCCEED,
    data,
  }),
  fetchNotifyActionFailed: (err) => ({
    type: FETCH_NOTIFY_FAILED,
    err,
  }),
};
